import React from "react";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, Input } from "../../../../forms";
import { RapidForm } from "../../../../rapidform";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { getFormById } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./RefillPrepaidForm.less";

interface StateProps {
    prepaidRefillForm: Form;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitDetails: () => void;
}

const RefillPrepaidForm: React.FC<PersonalDetailsFormProps> = ({ prepaidRefillForm, onSubmitDetails }) => {
    return (
        <div className="refill-prepaid-form">
            <RapidForm
                id={FORM_ID.REFILL_PREPAID}
                action={"#"}
                errors={prepaidRefillForm.errors}
                values={prepaidRefillForm.values}
                visible={prepaidRefillForm.visible}
                started={prepaidRefillForm.started}
                onSubmit={onSubmitDetails}
            >
                <FieldSet name="prepaidPhoneNumber">
                    <Input
                        className="refill-prepaid-form__phone-field"
                        type="tel"
                        name={VALIDATION_FIELD.PRODUCT_USER_PHONE}
                        label={`${TEXT.REFILL.PHONE_NUMBER_INPUT_LABEL}:`}
                        data-di-mask
                    />
                </FieldSet>
            </RapidForm>
        </div>
    );
};
const mapStateToProps = (state: RootState): StateProps => ({
    prepaidRefillForm: getFormById(state, FORM_ID.REFILL_PREPAID),
});

export default connect(mapStateToProps)(RefillPrepaidForm);
